import { z } from 'zod'

// TODO(roman): dup of dsp-api
export const DspEntityId = z.string().uuid()
export type DspEntityId = z.infer<typeof DspEntityId>
